module.exports = __webpack_public_path__ + "img/coming-soon-dark.ba745ba7.svg";